import environment from "@/commons/utils/environment";

export const getCookie = (name) => {
  const cookies = document.cookie.split("; ");
  const cookie = cookies.find((row) => row.startsWith(`${name}=`));
  return cookie ? cookie.split("=")[1] : null;
};

export const filterPilihProdiAPI = (basePath, {
  apiWithFilter = "",
  defaultAPI = "",
} = {}) => {
  const programStudiId = getCookie("selectedProdi");

  if (programStudiId && apiWithFilter) {
    const replacedapiWithFilter = apiWithFilter.replace("{programStudiId}", programStudiId);
    return `${environment.rootApi}${basePath}/${replacedapiWithFilter}`;
  }

  return `${environment.rootApi}${basePath}/${defaultAPI}`;
};